import { useState, useEffect } from 'react';
import { GENERAL } from 'utils/constants';

function useIsMobile(size = GENERAL.tabletSize) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= size);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= size);
    }
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
}

export default useIsMobile;
